// extracted by mini-css-extract-plugin
module.exports = {"root":"HorizontalRule-root-a6cdc1d64003eb06d1505c8b23d2fb4d"};